<template>
  <div class="text-tip-container">
    <el-tooltip
      v-if="showTooltip"
      :content="slotText"
      :placement="placement"
      :effect="effect"
      :disabled="!showTooltip"
    >
      <span
        :class="['text-content', { 'text-ellipsis': type === 'auto' }]"
        style="cursor: pointer"
        @click="copyText"
      >
        {{ truncatedText }}
      </span>
    </el-tooltip>
    <span
      v-else
      :class="['text-content', { 'text-ellipsis': type === 'auto' }]"
      style="cursor: pointer"
      @click="copyText"
    >
      <slot />
    </span>
  </div>
</template>

<script>
import { copy } from '@/utils'
export default {
  name: 'TextTip',
  props: {
    // 字数限制，超过此值显示tooltip
    maxLength: {
      type: Number,
      default: 20
    },
    // tooltip 显示位置
    placement: {
      type: String,
      default: 'top'
    },
    // tooltip 主题
    effect: {
      type: String,
      default: 'dark'
    },
    type: {
      type: String,
      default: ''
    },
    // 是否在文本末尾显示省略号
    showEllipsis: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // 获取slot内容文本
    slotText() {
      // 创建一个临时div来获取slot内容的纯文本
      const tempDiv = document.createElement('div')
      // 获取所有子节点
      const slotNodes = this.$slots.default || []
      // 遍历子节点，提取文本内容
      slotNodes.forEach(node => {
        if (node.text) {
          tempDiv.textContent += node.text
        } else if (node.children) {
          // 处理嵌套节点
          node.children.forEach(childNode => {
            if (childNode.text) {
              tempDiv.textContent += childNode.text
            }
          })
        }
      })
      return tempDiv.textContent
    },
    // 是否显示tooltip
    showTooltip() {
      if (this.type === 'auto') {
        return true
      }
      return this.slotText.length > this.maxLength
    },
    // 截断后的文本
    truncatedText() {
      if (this.type === 'auto') {
        return this.slotText
      }
      if (this.slotText.length <= this.maxLength) {
        return this.slotText
      }
      return (
        this.slotText.substring(0, this.maxLength) +
        (this.showEllipsis ? '...' : '')
      )
    }
  },
  methods: {
    // 复制文本到剪贴板
    async copyText() {
      copy(this.slotText)
      this.$message.success({
        message: '复制成功',
        customClass: 'amap-sug-result'
      })
    },

    // 旧浏览器复制文本的兼容方案
    fallbackCopyTextToClipboard(text) {
      const textArea = document.createElement('textarea')
      textArea.value = text

      // 设置样式，避免在页面上显示
      textArea.style.position = 'fixed'
      textArea.style.left = '-999999px'
      textArea.style.top = '-999999px'

      document.body.appendChild(textArea)
      textArea.focus()
      textArea.select()

      try {
        document.execCommand('copy')
        this.showCopySuccess()
      } catch (err) {
        console.error('复制失败:', err)
      } finally {
        document.body.removeChild(textArea)
      }
    },

    // 显示复制成功提示
    showCopySuccess() {
      // 使用ElMessage显示复制成功提示
      if (this.$message) {
        this.$message.success('复制成功')
      }
    }
  }
}
</script>

<style scoped lang="scss">
.text-tip-container {
  display: inline-block;
  position: relative;
  width: 100%;
}

.text-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-block;
  max-width: 100%;
  vertical-align: middle;
}
.text-ellipsis {
  overflow: hidden;
}
</style>
